import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { areArraysDifferents, getSortedData } from './utils';
const DraggableListDataContext = createContext({});
export const DraggableListDataProvider = ({ children, dataSource: initialDataSource, onDataChange, }) => {
    const [dataSource, setDataSource] = useState(initialDataSource);
    const [sortedIds, setSortedIds] = useState(dataSource.map((datum) => datum.id));
    const updateDataSourceByItem = useCallback((newItem) => {
        const newDataSource = dataSource.map((item) => item.id === newItem.id ? Object.assign(Object.assign({}, item), newItem) : item);
        setDataSource(newDataSource);
        onDataChange(newDataSource);
    }, [dataSource, setDataSource, onDataChange]);
    useEffect(() => {
        const sortedDataSource = getSortedData(sortedIds, dataSource);
        if (areArraysDifferents(dataSource, sortedDataSource)) {
            setDataSource(sortedDataSource);
            onDataChange(sortedDataSource);
        }
    }, [dataSource, sortedIds, onDataChange]);
    const value = useMemo(() => ({
        dataSource,
        setSortedIds,
        sortedIds,
        updateDataSourceByItem,
    }), [dataSource, sortedIds, updateDataSourceByItem]);
    return (_jsx(DraggableListDataContext.Provider, { value: value, children: children }));
};
export const useDraggableList = () => useContext(DraggableListDataContext);
//# sourceMappingURL=DraggableListContext.js.map